import { filter, map } from 'rxjs/operators'
import { ofType, ActionsObservable, StateObservable } from 'redux-observable'
import { roomTypes } from '../../../actions/room/roomTypes'
import { ReduxAction, State } from '../../../reducers/reducerType'
import { setMediaType } from '../../../actions/room/room'
import { mediaType as MediaType } from '@bt-react/constants'

/** Turn Spotlight off in participant is disconnected and auto Spotlight is off */
export const checkPresenterDisconnected$ = (action$: ActionsObservable<ReduxAction>, state$: StateObservable<State>) => action$.pipe(
  ofType(roomTypes.PRESENTER_DISCONNECTED),
  filter(() =>
    state$.value.syncUi.mediaType === MediaType.SPOTLIGHT &&
    state$.value.syncUi.focusOn !== null &&
    !state$.value.syncUi.autoSpotlight &&
    !Array.from(state$.value.room.room ? state$.value.room.room.participants.values() : []).map(({identity}) => identity).includes(state$.value.syncUi.focusOn)),
  map(() => setMediaType(MediaType.WEBCAM))
)

export default checkPresenterDisconnected$
